import React, { useState, useContext, useEffect } from 'react'

//Node Modules
import Navbar from 'react-bootstrap/Navbar'
import { useTranslation } from 'react-i18next'

//Components
import ContentNavigation from 'components/ContentNavigation'

//Contexts
import { ParentSortContext } from 'context/content-context'

import { TopIcon } from 'components/SASIcon'

//Styles
import styles from './MainContentArea.module.scss'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  title?: React.ReactNode
  prev?: string
  next?: string
  content: React.ReactNode
  minimal?: boolean
  versionPicker?: React.ReactNode
  docsetVersionPicker?: React.ReactNode
}

const MainContentArea = ({title, prev, next, content, minimal, versionPicker, docsetVersionPicker}:Props) => {
  const { t } = useTranslation()
  const [scrollVisible, setScrollVisible] = useState(false)
  const [globalHeaderVisible, setGlobalHeaderVisible] = useState(true)
  const [currScroll, setCurrScroll] = useState(0)
  const isSmallDevice = useIsSmallDevice()
  const parentSortContext = useContext(ParentSortContext)

  function handleScroll(event: React.UIEvent) {
    const scrollTop = (event.target as HTMLElement).scrollTop
    setScrollVisible(scrollTop >= 200)
    //only do for mobile view
    if (isSmallDevice) {
      if (currScroll > scrollTop) {  //scroll up
        if (!globalHeaderVisible) {
          setGlobalHeaderVisible(true)
        }
      } else {  //scroll down
        if (globalHeaderVisible && scrollTop >=200) {
          setGlobalHeaderVisible(false)
        }
      }
      setCurrScroll(scrollTop)
    }
  }

  function handleScrollToTop() {
    let el = document.getElementById('MainContentSection')
    if(el) {
      el.scrollTop = 0
    }
    setScrollVisible(false)
  }

  if (parentSortContext.parentSort) {
    title= null
  }

  useEffect( () => { //set global header visibility
    let el = document.getElementById('root')
    if (globalHeaderVisible) {
      el?.classList.add("showBanner")
      el?.classList.remove("hideBanner")
    } else {
      el?.classList.add('hideBanner')
      el?.classList.remove("showBanner")
    }
  },[globalHeaderVisible])

  useEffect(()=> {
    if (!isSmallDevice) {
      setGlobalHeaderVisible(true);
    }
  }, [isSmallDevice])

  return (
    <>
      <div className={styles.main}>
        { !minimal && 
          <Navbar className={`${styles.mainContentNav} ${isSmallDevice ? styles.isSmallDevice : ''}`} as="div" role="none">
            <div className={styles.leftNav}>
              { docsetVersionPicker ? docsetVersionPicker : null}
              { <div className={title ? styles.title : ''}>{title}</div> || <div /> }
              {isSmallDevice && !docsetVersionPicker ? <><span className={styles.vertDivider}> {title ? '|' : null }</span>{versionPicker} </>: null}
            </div>
            
            <div className={styles.pagenav}><ContentNavigation prev={prev} next={next} /></div>
          </Navbar>
        }
        <section id='MainContentSection' className={styles.content} tabIndex={0} onScroll={handleScroll}>
          <div tabIndex={-1} className={isSmallDevice ? '' : styles.maxHeight}>
            { content }
          </div>
        </section>
        <button
          className={`${styles.scrollToTop} ${scrollVisible ? styles.visible : styles.hidden}`}
          title={t('helpcenter-gui-icu.content.navigation.top.label')}
          onClick={handleScrollToTop}
        >
          <TopIcon />
        </button>
      </div>
    </>
  )
}

export default MainContentArea